import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, AfterViewInit, inject, computed } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { isPlatformBrowser, AsyncPipe } from '@angular/common';
import { Blog } from '../../../blogs/models';
import { map } from 'rxjs/operators';

import * as fromRoot from '../../../store';
import { DiseaseProfile } from '../../models';
import { getSelectedDiseaseProfile } from '../../store';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@teamfoster/sdk/icon';
import { SafePipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { getCookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';

@Component({
  selector: 'app-disease-profile-info',
  templateUrl: './disease-profile-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, IconComponent, AsyncPipe, UrlRewritePipe, StripEmbedPipe, SafePipe],
})
export class DiseaseProfileInfoComponent {
  #store = inject(Store);

  profile$ = this.#store.selectSignal(getSelectedDiseaseProfile);
  contentType = this.#store.selectSignal(fromRoot.getRouterState);
  contentType$ = computed(() => {
    const state = this.contentType();
    if (!state) {
      return null;
    }
    return state.state.params['contentType'] || state.state.data['contentType'];
  });

  cookiesAccepted$ = this.#store.selectSignal(getCookiePreferences);

  content$ = computed(() => {
    const type = this.contentType$();
    const profile = this.profile$();
    if (!type || !profile) {
      return undefined;
    }
    return profile.informationPages?.find(a => a.slug.toLowerCase() === type.toLowerCase());
  });
}
